import {
    Dropdown,
    DropdownItem,
    UNDERLINE_TAB_ATTR,
    UnderlineTabBar,
    underlineTabItemClassName,
    underlineTabLabelClassName
} from '@frontend/components/common';
import React from 'react';
import { IconType } from 'react-icons';
import { LuChevronDown } from 'react-icons/lu';

import { ModalItemDropdownOption } from '../modal-item/modal-item';

interface ModalTabNavProps {
    modalTabItems: {
        order?: number;
        label?: React.ReactNode;
        icon?: IconType;
        identifier: string;
        main?: boolean;
        dropdownOptions?: ModalItemDropdownOption[];
    }[];
    onChange: (key: string) => void;
    activeSubsection?: string;
    activeDropdownOption?: string;
    onDropdownChange?: (tabIdentifier: string, optionIdentifier: string) => void;
}

export const ModalTabNav = (props: ModalTabNavProps) => {
    const activeKey = props.activeSubsection?.toLowerCase();

    return (
        <UnderlineTabBar activeKey={activeKey}>
            {props.modalTabItems.map((key) => {
                const tabKey = key.identifier.toLowerCase();
                const selectedTab = activeKey === tabKey;

                if (key.dropdownOptions && key.dropdownOptions.length > 0) {
                    return (
                        <div
                            key={key.identifier}
                            {...{ [UNDERLINE_TAB_ATTR]: tabKey }}
                            className={underlineTabItemClassName(selectedTab)}>
                            <Dropdown
                                label={
                                    <span className={`flex items-center gap-1 ${underlineTabLabelClassName(selectedTab)}`}>
                                        {key.label ?? key.identifier}
                                        <LuChevronDown className='size-4' />
                                    </span>
                                }
                                buttonStyle='bg-transparent border-none p-0 hover:cursor-pointer text-inherit font-inherit'
                                hideChevron>
                                {key.dropdownOptions.map((option) => (
                                    <DropdownItem
                                        key={option.identifier}
                                        label={option.label}
                                        onMouseDown={(event) => {
                                            // Portaled menu sits outside the pane; stop mousedown
                                            // so ModalProvider does not treat it as backdrop dismiss.
                                            event.stopPropagation();
                                        }}
                                        onClick={() => {
                                            // Only onDropdownChange — onChange alone would clear the URL dropdown
                                            // and fire a second navigate on the same click.
                                            if (props.onDropdownChange) {
                                                props.onDropdownChange(key.identifier, option.identifier);
                                            } else {
                                                props.onChange(key.identifier);
                                            }
                                        }}
                                    />
                                ))}
                            </Dropdown>
                        </div>
                    );
                }

                return (
                    <div
                        key={key.identifier}
                        {...{ [UNDERLINE_TAB_ATTR]: tabKey }}
                        onClick={() => props.onChange(key.identifier)}
                        data-testid={`nav-item${key.identifier}`}
                        className={`${underlineTabItemClassName(selectedTab)} hover:cursor-pointer`}>
                        <a
                            data-tab-target={key.identifier}
                            role='tab'
                            aria-selected={selectedTab}
                            className={underlineTabLabelClassName(selectedTab)}>
                            {key.label ?? key.identifier}
                        </a>
                    </div>
                );
            })}
        </UnderlineTabBar>
    );
};
